import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBK5xL44MILgHvNxq6nzT3-JUVjnd2OPuU",
  authDomain: "acceso7-32ad3.firebaseapp.com",
  projectId: "acceso7-32ad3",
  storageBucket: "acceso7-32ad3.firebasestorage.app",
  messagingSenderId: "743099229873",
  appId: "1:743099229873:web:02901ad3a63b14f5b5a490",
  measurementId: "G-NN3H25VGQL"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// Inicializar Firebase Messaging (solo en el navegador)
let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Messaging no disponible:', error);
  }
}
export { messaging };

// Configurar Google Auth
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Persistencia de sesión: que el usuario siga logueado al actualizar la página
if (typeof window !== 'undefined') {
  setPersistence(auth, browserLocalPersistence).catch((err) => {
    console.warn('No se pudo configurar persistencia de auth:', err.message);
  });
  auth.settings.appVerificationDisabledForTesting = false;
}

export default app;
